import React from "react"
import { COLORS } from "../../utils"
import { Chip, Stack, styled } from "@mui/material"
import { getTabsBySidebareId } from "../../utils/productionStepExecution"

const options = [
    { value: "TODO", label: "À démarrer" },
    { value: "IN_PROGRESS", label: "En cours" },
    { value: "LOCKED", label: "En attente" },
    { value: "DONE", label: "Terminées" },
]

const selectedTabColors = {
    "TODO": COLORS.BLUE_600,
    "IN_PROGRESS": COLORS.ORANGE_300,
    "LOCKED": COLORS.BLACK_200,
    "DONE": COLORS.GREEN_500,
}

const getOptions = (selectedMenu) => {
    const tabs = getTabsBySidebareId(selectedMenu)
    if (!tabs) return options
    return options.filter(option => tabs.includes(option.value))
}

const StyledBadge = styled("div", {
    shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "selectedColor" && prop !== "count"
})(({ isSelected = false, selectedColor, count }) => {
    const defaultSelectedColor = selectedColor || COLORS.BLUE_600

    const styles = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "16px",
        fontWeight: 400,
        padding: "4px 8px",
        borderRadius: "64px",
        width: "32px",
        height: "32px",
        textAlign: "center",
        backgroundColor: "#ffffff",
        color: COLORS.BLACK800,
        border: isSelected ? `1px solid ${defaultSelectedColor}` : `1px solid ${COLORS.BLACK_200}`,
    }

    if (isSelected) {
        styles.fontWeight = 500
        styles.color = count === 0 ? "#2196F3" : defaultSelectedColor
    }
    return styles
})

const StyledTab = styled(Chip, {
    shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "selectedColor"
})(({ isSelected = false, selectedColor }) => {
    const defaultSelectedColor = selectedColor || COLORS.BLUE_600
    return {
        height: 48,
        display: "flex",
        alignItems: "center",
        gap: 12,
        justifyContent: "space-between",
        padding: "8px 8px 8px 12px",
        borderRadius: 64,
        backgroundColor: isSelected ? defaultSelectedColor : "#FFFFFF",
        border: isSelected ? `1px solid ${defaultSelectedColor}` : "1px solid #FFFFFF",
        cursor: "pointer",
        margin: "0 !important",
        "&:hover": {
            opacity: 0.85,
            backgroundColor: isSelected ? defaultSelectedColor : "#FFFFFF",
        },
        "& .MuiChip-label": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            padding: 0,
            fontSize: 18,
            fontWeight: isSelected ? 500 : 400,
            lineHeight: 1.33,
            color: isSelected ? "#FFFFFF" : COLORS.BLACK_600,
        },
        "&.tab-chip-LOCKED-selected *": {
            color: COLORS.BLACK_600 + " !important"
        }
    }
})

const PSEsTabs = ({
    tab,
    tabs,
    onTabChange,
    notificationCount = {},
    selectedMenu,
}) => {
    const handleChange = (status) => {
        onTabChange(status)
    }
    return (
        <Stack direction="row" spacing={3} flexWrap="wrap" gap={4}>
            {(tabs ?? getOptions(selectedMenu)).map((option) => {
                const isSelected = tab === option.value
                const currentSelectedColor = selectedTabColors[option.value]
                const count = notificationCount[option.value] || 0

                return (
                    <StyledTab
                        className={`tab-chip-${option.value}${isSelected ? "-selected" : ""}`}
                        key={option.value}
                        label={
                            <>
                                <span>{option.label}</span>
                                <StyledBadge isSelected={isSelected} selectedColor={currentSelectedColor} count={count}>
                                    {count}
                                </StyledBadge>
                            </>
                        }
                        onClick={() => handleChange(option.value)}
                        isSelected={isSelected}
                        selectedColor={currentSelectedColor}
                    />
                )
            })}
        </Stack>
    )
}

export default PSEsTabs